import type { ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

import { formatErrorToString, getTestProps } from '../../lib/helpers';

export interface HelpErrorTextsProps {
  /**
   * Field text that will inform about error
   */
  error?: unknown;
  /**
   * Help text under field
   */
  helpText?: ReactNode;
}

export interface HelpErrorTextsTemplateProps extends HelpErrorTextsProps {
  /**
   * Error field additional error classes
   */
  additionalErrorClasses?: string;
  /**
   * Help text field additional error classes
   */
  additionalHelpClasses?: string;
  /**
   * Field test id
   */
  testId?: string;
}

const HelpErrorTextsTemplate = ({
  helpText = '',
  error = '',
  additionalErrorClasses = '',
  additionalHelpClasses = '',
  testId = '',
}: HelpErrorTextsTemplateProps) => {
  const finalErrors = formatErrorToString(error);
  return (
    <>
      {helpText && (
        <div
          className={twMerge(
            'text-sm mt-1 mb-1 leading-none text-left break-all dark:text-slate-200',
            finalErrors && 'text-red',
            additionalHelpClasses,
          )}
          {...getTestProps(testId, 'help-text')}
        >
          {helpText}
        </div>
      )}
      {finalErrors && (
        <div
          className={twMerge(
            'text-red text-sm',
            'mt-1 mb-2 leading-none text-left',
            additionalErrorClasses,
          )}
          {...getTestProps(testId, 'error-text')}
        >
          {finalErrors}
        </div>
      )}
    </>
  );
};

export default HelpErrorTextsTemplate;
